module.exports = __webpack_public_path__ + "img/2-largo.3aaa2e5a.jpg";